import cn from 'classnames';

const Quote = ({ author, paddingTop, paddingBottom }) => (
  <section className={cn({ 'pt-14': paddingTop, 'pb-20': paddingBottom })}>
    <div className="container flex justify-end">
      <div className="pl-8 border-l md:basis-2/3 border-scale-lightmauve">
        <p className="mb-8 text-lg text-black md:text-3xl font-aeonik">{author.quote}</p>
        {author && (
          <div className="flex items-center shrink">
            {author.avatar && (
              <img
                className="w-[60px] h-[60px] mr-4 rounded-full"
                src={author.avatar}
                alt={author.name}
              />
            )}
            <div>
              <p className="mb-1 text-black text-lx">{author.name}</p>
              <p className="text-base text-neutral-600 md:flex">
                {author.position}
                {author.company && (
                  <>
                    ,&nbsp;<span className="block md:inline-block"> {author.company}</span>
                  </>
                )}
              </p>
            </div>
          </div>
        )}
      </div>
    </div>
  </section>
);

export default Quote;
